import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { ThemeService } from 'src/app/shared/services/theme.service';

@Component({
  selector: 'app-centre-competence-menu',
  templateUrl: './centre-competence-menu.component.html',
  styleUrls: ['./centre-competence-menu.component.less']
})
export class CentreCompetenceMenuComponent {

  sections = [
    {
      label: 'Localisation FEB',
      icon: 'place',
      route: '/core/admin/feb-locations-management'
    },
    {
      label: 'Nomenclature FEB',
      icon: 'format_list_bulleted',
      route: '/core/admin/feb-activite-uo-nomenclature-management'
    },
    {
      label: 'UO Évaluation',
      icon: 'corporate_fare',
      route: '/core/admin/uo-evaluation'
    },
    {
      label: 'Catégories',
      icon: 'folder',
      route: '/core/admin/categorie-evaluation'
    },
    {
      label: "Compétences",
      icon: 'school',
      route: '/core/admin/competence-evaluation'
    }
  ];

  constructor(public theme: ThemeService, private router: Router) {}

  navigate(route: string): void {
    this.router.navigate([route]);
  }
}
